import Vue from 'vue'
import Router from 'vue-router'

// Containers
const TheContainer = () => import('@/containers/TheContainer')

// Views
const Dashboard = () => import('@/views/Dashboard')

// Views - Actividades
const GestionActividades = () => import('@/views/actividades/GestionActividades')
const RevisarTareas = () => import('@/views/actividades/RevisarTareas')


// Views - Usuarios
const ConsultaPerfil = () => import('@/views/usuario/ConsultaPerfil')

// Views - Mis Horarios
const HorarioClases = () => import('@/views/horarios/HorarioClases')

// Views - Páginas
const Page404 = () => import('@/views/pages/Page404')
const SesionFinalizada = () => import('@/views/pages/SesionFinalizada')
const ColegioInactivo = () => import('@/views/pages/ColegioInactivo')
const Login = () => import('@/views/pages/Login')
const RestaurarClave = () => import('@/views/pages/RestaurarClave')

Vue.use(Router)

export default new Router({
  mode: 'hash', // https://router.vuejs.org/api/#mode
  linkActiveClass: 'active',
  scrollBehavior: () => ({ y: 0 }),
  routes: configRoutes()
})

function configRoutes () {
  return [
    {
      path: '/',
      redirect: '/dashboard',
      name: 'Inicio',
      component: TheContainer,
      children: [
        {
          path: 'dashboard',
          name: 'Dashboard',
          component: Dashboard
        },
        {
          path: 'usuario',
          redirect: '/usuario/consultaperfil',
          name: 'Usuario',
          component: {
            render (c) { return c('router-view') }
          },
          children: [
            {
              path: 'consultaperfil',
              name: 'Perfil de Usuario',
              component: ConsultaPerfil
            }
          ]
        },
        {
          path: 'actividades',
          redirect: '/actividades/gestionactividades',
          name: 'Aula Virtual',
          component: {
            render (c) { return c('router-view') }
          },
          children: [
            {
              path: 'gestionactividades',
              name: 'Gestion de Actividades',
              component: GestionActividades
            },
            {
              path: 'revisartareas',
              name: 'Revisar Tareas',
              component: RevisarTareas
            }
          ]
        },
        {
          path: 'horarios',
          redirect: '/horarios/horarioclases',
          name: 'Horarios',
          component: {
            render (c) { return c('router-view') }
          },
          children: [
            {
              path: 'horarioclases',
              name: 'Horario de Clases',
              component: HorarioClases
            }
          ]
        }
      ]
    },
    {
      path: '/pages/login',
      name: 'Login',
      component: Login
    },
    {
      path: '/pages/restaurarclave',
      name: 'RestaurarClave',
      component: RestaurarClave
    },
    {
      path: "/pages/sesionfinalizada",
      name: 'SesionFinalizada',
      component: SesionFinalizada
    },
    {
      path: "/pages/colegioinactivo",
      name: 'ColegioInactivo',
      component: ColegioInactivo
    },
    {
      path: "*",
      name: 'Page404',
      component: Page404
    }  
  ]
}

